/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_NewInputs */

const cs_settings_users_new = /** @type {(inputs: Settings_Users_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový uživatel`)
};

const en_settings_users_new = /** @type {(inputs: Settings_Users_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New user`)
};

/**
* | output |
* | --- |
* | "New user" |
*
* @param {Settings_Users_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_new = /** @type {((inputs?: Settings_Users_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_new(inputs)
	return cs_settings_users_new(inputs)
});